import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#969696", d: "M8.64 8 5.67 5.03l.85-.85L10.33 8l-3.81 3.82-.85-.85z" }));
export default SvgArrowRight;
